import React, { createContext, useContext } from 'react'

/**
 * @typedef {import('./appProvider').AppData} AppData
 */

const AppContext = createContext({})

/** @returns {Partial<AppData>} */
export const useAppContext = () => useContext(AppContext)

/** @type {import("./appProvider").default} */
export const AppProvider = ({ value = {}, children }) => {
  return <AppContext.Provider value={value}>{children}</AppContext.Provider>
}
